import { api } from "@/api/client";

/** Конфигурация портала (публичная, до входа). Пока в ней только то, что нужно
 *  экрану входа: включён ли вход через SSO. */
export interface PortalConfig {
  sso_enabled: boolean;
}

export async function getPortalConfig(): Promise<PortalConfig> {
  const { data } = await api.get<PortalConfig>("/config");
  return data;
}
